import {
	blackColors,
	backgroundColor,
	whiteColor,
	defaultFont,
	dangerColor,
} from 'assets/jss/material-dashboard-pro-react';

const usageStyle = (theme) => ({
	noCalls: {
		marginTop: 72,
		marginBottom: 250,
		fontFamily: theme.fontFamily.albert.regular,
		fontSize: theme.fontSize(16),
		lineHeight: `${theme.fontSize(22)}px`,
		[theme.breakpoints.up('sm')]: {
			marginBottom: 72,
		},
	},
	center: {
		textAlign: 'center',
	},
	connectionType: {
		margin: '0 0 0 4px',
	},
	header: {
		marginBottom: 8,
	},
	balanceProgress: {
		marginBottom: 0,
	},
	balanceCard: {
		[theme.breakpoints.down('md')]: {
			marginBottom: 20,
		},
	},
	balanceElement: {
		[theme.breakpoints.down('md')]: {
			marginTop: 15,
		},
	},
	bundleLeft: {
		fontFamily: defaultFont,
		fontWeight: 'bold',
		fontSize: 12,
		lineHeight: '16px',
		display: 'inline-block',
		marginLeft: 3,
	},
	topUpButtonContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
	},
	thing: {
		width: 12,
		height: 12,
		transform: 'rotate(45deg)',
		position: 'absolute',
		backgroundColor: whiteColor,
		top: 27,
		left: -7,
	},
	specialPackage: {
		display: 'flex',
	},
	specialPackageIcon: {
		margin: '8px 20px 0 0',
		'& img': {
			width: 48,
		},
	},
	specialPackageCard: {
		marginTop: 0,
		width: 'calc(100% - 68px)',
		display: 'inline-block',
	},
	generalUsageCard: {
		marginBottom: '0 !important',
		marginTop: 0,
		'& > div': {
			[theme.breakpoints.up('sm')]: {
				padding: '24px 162px 18px 32px',
			},
		},
	},
	unlimitedSubIcon: {
		width: 27,
		position: 'absolute',
		bottom: 16,
		color: blackColors[3],
	},
	totalCardContainer: {
		display: 'flex',
		paddingBottom: 20,
	},
	totalCardIcon: {
		'& img': {
			width: 48,
			marginRight: 8,
		},
	},
	totalCardUsage: {
		width: 'calc(100% - 56px)',
	},
	bundlesCategory: {
		marginBottom: 14,
	},
	usageContainer: {
		display: 'flex',
		'& > div': {
			width: '100%',
		},
		'& > div:nth-child(2)': {
			textAlign: 'right',
		},
	},
	iconContainer: {
		marginRight: '58px',
		'& svg': {
			height: 56,
			width: 56,
			color: blackColors[4],
		},
	},
	linearBar: {
		marginBottom: 5,
		height: 4,
	},
	cardBreak: {
		width: '100%',
		height: 2,
		backgroundColor,
	},
	bundleSubpackageCard: {
		height: 'calc(100% - 16px)',
	},
	bundleSubpackage: {
		padding: 0,
		marginTop: 8,
		'& > div': {
			marginTop: 0,
		},
	},
	bundleContainer: {
		minHeight: 57,
		// height: '100%',
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
	},
	bundleCardBody: {
		height: '100%',
	},
	leftBundleNumber: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	allBundle: {
		marginTop: 'auto',
		marginBottom: 4,
		textAlign: 'right',
		width: '100%',
	},
	leftBundle: {
		display: 'table-cell',
		paddingLeft: '8px',
		'& > *': {
			marginBottom: 1,
		},
	},
	warningMessage: {
		color: dangerColor[0],
	},
	unlimitedIcon: {
		color: blackColors[3],
		width: 27,
	},
	unit: {
		marginLeft: 5,
		fontSize: 13,
		lineHeight: '26px',
		display: 'inline',
		fontWeight: 'bold',
	},
	showDetailsButton: {
		position: 'absolute',
		top: 7,
		right: 17,
		margin: 0,
	},
	deleteIcon: {
		'& svg': {
			color: blackColors[4],
		},
	},
	counter: {
		fontSize: 8,
		letterSpacing: '-.3px',
		color: blackColors[3],
		position: 'relative',
		bottom: 10,
		paddingLeft: 6,
		paddingRight: 14,
		'&:only-child': {
			bottom: -7,
		},
	},
	connectionTypeCellValue: {
		paddingRight: '4px',
	},
	usageCard: {
		position: 'relative',
		marginTop: 0,
		height: 'calc(100% - 16px)',
		'& > div': {
			paddingBottom: 0,
		},
	},
	connectionList: {
		marginRight: 8,
	},
	connectionListContainer: {
		marginTop: 38,
		marginBottom: 20,
	},
	datePicker: {
		width: 'calc(50% - 4px)',
		display: 'inline-block',
		'&:first-child': {
			marginRight: 4,
		},
		'&:nth-child(2)': {
			marginLeft: 4,
		},
	},
	usageDetailsHeader: {
		display: 'flex',
		justifyContent: 'flex-start',
	},
	totalContainer: {
		width: '100%',
	},
	dataUsageContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	linearProgressContainer: {
		width: '100%',
		padding: '16px',
	},
	linearProgress: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
	},
});

export default usageStyle;
